/* =========================================================
   BEHER CLAIMS CENTER — beher-claims.js (v2026-11-02-b)
   Vanilla JS. Sin dependencias externas.
   Todo el estado vive en memoria (nunca en localStorage).
   ========================================================= */
(function () {
  "use strict";

  var ICONS = {
    tracking:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>',
    quality:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="9" r="5.5"/><path d="M8.5 13.5 7 21l5-2.5L17 21l-1.5-7.5"/></svg>',
    damage:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 8l3-4h10l3 4v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M9 12l2 2 4-5"/></svg>',
    item:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    other:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M21 12a8.5 8.5 0 1 1-3.2-6.6"/><path d="M20 4v5h-5"/><circle cx="12" cy="12" r="0.6" fill="currentColor"/></svg>',
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7"/></svg>',
    upload:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 16V4M8 8l4-4 4 4"/><path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>'
  };

  function track(eventName, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, extra || {}));
    } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
  }

  function normalizeOrder(v) {
    return String(v || "").trim().replace(/^#/, "");
  }

  function init(root) {
    if (root.getAttribute("data-already-submitted") === "true") {
      track("beher_claim_success", {});
      return; // Liquid ya renderizó la pantalla de éxito; el wizard no se monta.
    }

    root.setAttribute("data-claims-version", "2026-11-02-b");

    var cfg = {
      trackingUrl: root.getAttribute("data-tracking-url") || "",
      accountOrdersUrl: root.getAttribute("data-account-orders-url") || "",
      enabled: {
        tracking: root.getAttribute("data-enable-tracking") === "true",
        quality: root.getAttribute("data-enable-quality") === "true",
        shipping_damage: root.getAttribute("data-enable-shipping-damage") === "true",
        order_item_issue: root.getAttribute("data-enable-order-item-issue") === "true",
        other: root.getAttribute("data-enable-other") === "true"
      },
      copy: {
        successHeading: root.getAttribute("data-success-heading") || "Thank you",
        successBody: root.getAttribute("data-success-body") || "Your claim has been submitted.",
        privacy: root.getAttribute("data-privacy-copy") || "",
        photoNotice: root.getAttribute("data-photo-notice") || ""
      }
    };

    var nativeForm = document.getElementById("beher-claims-form");
    var stage = root.querySelector("[data-beher-stage]");
    var progressEl = root.querySelector("[data-beher-progress]");
    var progressLabel = root.querySelector("[data-beher-progress-label]");
    var liveRegion = root.querySelector("[data-beher-live]");

    var state = {
      claimType: null,
      claimSubtype: null,
      currentFlow: [],
      currentIndex: 0,
      orderNumber: "",
      email: "",
      description: "",
      files: [], // {file, url}
      fields: {}, // step-specific extra fields
      submitting: false
    };

    // ---------------------------------------------------------
    // FLOWS: orden de pasos por claim_type
    // ---------------------------------------------------------
    var FLOWS = {
      start: ["start"],
      tracking: ["trackingInfo"],
      tracking_help: ["trackingIssueType", "trackingOrder", "trackingDetails", "review"],
      // En quality y shipping_damage el tipo de problema va PRIMERO: así
      // podemos mostrar la pantalla informativa ("info") antes de pedir
      // pedido y email, y resolver el ticket sin que el cliente rellene nada.
      // El paso "info" se inserta solo cuando el problema elegido tiene
      // contenido (ver buildFlow).
      quality: ["qualityType", "orderInfo", "details", "review"],
      shipping_damage: ["damageType", "orderInfo", "details", "review"],
      order_item_issue: ["orderInfo", "itemIssueType", "itemIssueFields", "details", "review"],
      other: ["otherFields", "review"]
    };

    var TRACKING_ISSUE_CARDS = [
      { id: "too_long", title: "My order is taking too long", subtitle: "" },
      { id: "not_updated", title: "Tracking hasn\u2019t updated", subtitle: "" },
      { id: "delivered_missing", title: "Tracking says delivered but I can\u2019t find it", subtitle: "" },
      { id: "lost", title: "My order may be lost", subtitle: "" },
      { id: "other_delivery", title: "Other delivery issue", subtitle: "" }
    ];

    var QUALITY_CARDS = [
      { id: "appearance", title: "Appearance", subtitle: "Color, look of the meat or fat" },
      { id: "white_dots", title: "White dots", subtitle: "Small white spots or crystals" },
      { id: "mold", title: "Mold", subtitle: "White or green film on the surface" },
      { id: "smell", title: "Smell" },
      { id: "taste", title: "Taste", subtitle: "Too salty or not as expected" },
      { id: "texture", title: "Texture" },
      { id: "melted", title: "Melted fat", subtitle: "Soft, glossy or oily fat" },
      { id: "packaging", title: "Packaging" },
      { id: "other_quality", title: "Other" }
    ];

    var DAMAGE_CARDS = [
      { id: "product", title: "Product", subtitle: "The product itself is damaged" },
      { id: "packaging", title: "Packaging", subtitle: "The box or bag is damaged" },
      { id: "both", title: "Both" },
      { id: "vacuum_lost", title: "Vacuum seal lost", subtitle: "The vacuum pack is loose or open" },
      { id: "arrived_warm", title: "Arrived warm", subtitle: "The package felt warm on arrival" }
    ];

    // ---------------------------------------------------------
    // INFO SCREENS: pantallas que explican un caso frecuente antes de
    // abrir la reclamación. El texto y la foto se editan en Customize
    // (si el texto queda vacío, esa pantalla se omite y se sigue al
    // formulario normal). Siempre hay un botón visible para continuar
    // con la reclamación: nunca se bloquea al cliente.
    // ---------------------------------------------------------
    var TYPE_STEP = {
      quality: "qualityType",
      shipping_damage: "damageType",
      delivery_issue: "trackingIssueType"
    };

    var INFO_ITEMS = {
      too_long: {
        claimType: "delivery_issue",
        title: "Good to know about delivery times",
        attr: "data-info-too-long",
        continueLabel: "It\u2019s been longer, file a ticket"
      },
      not_updated: {
        claimType: "delivery_issue",
        title: "Tracking can take up to 48 hours to update",
        attr: "data-info-not-updated",
        continueLabel: "It\u2019s been over 48 hours, file a ticket"
      },
      appearance: {
        claimType: "quality",
        title: "What to expect from the appearance",
        attr: "data-info-appearance",
        images: [
          { suffix: "-image", caption: "Normal color" },
          { suffix: "-image-2", caption: "Too dark or oxidized" }
        ],
        solvedLabel: "Mine looks normal",
        continueLabel: "Mine looks like the second photo"
      },
      white_dots: {
        claimType: "quality",
        title: "Those white dots are natural",
        attr: "data-info-white-dots",
        images: [{ suffix: "-image", caption: "" }],
        continueLabel: "I still want to file a claim"
      },
      mold: {
        claimType: "quality",
        title: "Surface mold is part of curing",
        attr: "data-info-mold",
        images: [{ suffix: "-image", caption: "" }],
        continueLabel: "Mine looks different, file a claim"
      },
      taste: {
        claimType: "quality",
        title: "What the flavor should be like",
        attr: "data-info-taste",
        continueLabel: "It still tastes wrong, file a claim"
      },
      melted: {
        claimType: "quality",
        title: "Soft or melted fat is normal in Ib\u00e9rico",
        attr: "data-info-melted",
        images: [{ suffix: "-image", caption: "" }],
        continueLabel: "I still want to file a claim"
      },
      vacuum_lost: {
        claimType: "shipping_damage",
        title: "About the vacuum seal",
        attr: "data-info-vacuum",
        images: [{ suffix: "-image", caption: "" }],
        continueLabel: "It\u2019s sliced or boneless, file a claim"
      },
      arrived_warm: {
        claimType: "shipping_damage",
        title: "About packages that arrive warm",
        attr: "data-info-warm",
        images: [{ suffix: "-image", caption: "" }],
        continueLabel: "I still want to file a claim"
      }
    };

    function getInfo(subtype, claimType) {
      var item = INFO_ITEMS[subtype];
      if (!item || item.claimType !== claimType) return null;
      var text = (root.getAttribute(item.attr + "-text") || "").trim();
      if (!text) return null; // texto vac\u00edo en Customize: pantalla desactivada
      var images = [];
      (item.images || []).forEach(function (img) {
        var src = root.getAttribute(item.attr + img.suffix) || "";
        if (src) images.push({ src: src, caption: img.caption });
      });
      return {
        title: item.title,
        paragraphs: text.split(/\r?\n+/).filter(function (p) { return p.trim(); }),
        images: images,
        solvedLabel: item.solvedLabel || "That answers my question",
        continueLabel: item.continueLabel
      };
    }

    function buildFlow(claimType, subtype) {
      var base = claimType === "delivery_issue" ? FLOWS.tracking_help : FLOWS[claimType];
      var flow = base.slice();
      if (getInfo(subtype, claimType)) {
        var idx = flow.indexOf(TYPE_STEP[claimType]);
        if (idx > -1) flow.splice(idx + 1, 0, "info");
      }
      return flow;
    }

    var ITEM_ISSUE_CARDS = [
      { id: "missing_item", title: "An item is missing" },
      { id: "wrong_item", title: "I received the wrong item" },
      { id: "wrong_quantity", title: "Wrong quantity" },
      { id: "other_item_issue", title: "Other" }
    ];

    var CLAIM_TYPE_LABELS = {
      tracking: "Order tracking",
      quality: "Product quality",
      shipping_damage: "Damaged during delivery",
      order_item_issue: "Missing or incorrect item",
      other: "Something else",
      delivery_issue: "Delivery issue"
    };

    // ---------------------------------------------------------
    // Render helpers
    // ---------------------------------------------------------
    function setStage(html) {
      stage.innerHTML = '<div class="beher-claims__step" data-step-el>' + html + "</div>";
      var stepEl = stage.querySelector("[data-step-el]");
      var heading = stepEl.querySelector("[data-focus-heading]");
      if (heading) {
        heading.setAttribute("tabindex", "-1");
        heading.focus({ preventScroll: false });
      }
      if (liveRegion && heading) liveRegion.textContent = heading.textContent;
      return stepEl;
    }

    function renderProgress() {
      if (!state.currentFlow.length || state.currentFlow.length < 2) {
        progressEl.hidden = true;
        progressLabel.hidden = true;
        return;
      }
      progressEl.hidden = false;
      progressLabel.hidden = false;
      var total = state.currentFlow.length;
      var current = state.currentIndex + 1;
      var dots = "";
      for (var i = 0; i < total; i++) {
        if (i > 0) dots += '<span class="beher-claims__progress-line"></span>';
        var cls = i < state.currentIndex ? "is-done" : i === state.currentIndex ? "is-active" : "";
        dots += '<span class="beher-claims__progress-dot ' + cls + '"></span>';
      }
      progressEl.innerHTML = dots;
      progressLabel.textContent = "Step " + current + " of " + total;
    }

    function cardListHtml(cards, groupName, iconKey) {
      return (
        '<div class="beher-claims__cards" role="group">' +
        cards
          .map(function (c) {
            return (
              '<button type="button" class="beher-claims__card" data-card="' +
              escapeHtml(c.id) +
              '" data-group="' +
              escapeHtml(groupName) +
              '">' +
              (iconKey ? '<span class="beher-claims__card-icon">' + ICONS[iconKey] + "</span>" : "") +
              '<span class="beher-claims__card-body">' +
              '<span class="beher-claims__card-title">' +
              escapeHtml(c.title) +
              "</span>" +
              (c.subtitle ? '<span class="beher-claims__card-subtitle">' + escapeHtml(c.subtitle) + "</span>" : "") +
              "</span></button>"
            );
          })
          .join("") +
        "</div>"
      );
    }

    function backButtonHtml() {
      return '<button type="button" class="beher-claims__back" data-action="back">\u2190 Back</button>';
    }

    // ---------------------------------------------------------
    // STEP: start
    // ---------------------------------------------------------
    function renderStart() {
      state.currentFlow = FLOWS.start;
      state.currentIndex = 0;
      var cards = [];
      if (cfg.enabled.tracking)
        cards.push({ id: "tracking", title: "Where is my order?", subtitle: "Check the status of my shipment", icon: "tracking" });
      if (cfg.enabled.quality)
        cards.push({ id: "quality", title: "Product quality issue", subtitle: "The product is not as expected", icon: "quality" });
      if (cfg.enabled.shipping_damage)
        cards.push({ id: "shipping_damage", title: "Damaged during delivery", subtitle: "The product or packaging arrived damaged", icon: "damage" });
      if (cfg.enabled.order_item_issue)
        cards.push({ id: "order_item_issue", title: "Missing or incorrect item", subtitle: "I didn\u2019t receive all or the right products", icon: "item" });
      if (cfg.enabled.other)
        cards.push({ id: "other", title: "Something else", subtitle: "Another issue with my order", icon: "other" });

      var html =
        '<h2 class="beher-claims__step-heading beher-claims__sr-only" data-focus-heading>File a claim</h2>' +
        '<div class="beher-claims__cards">' +
        cards
          .map(function (c) {
            return (
              '<button type="button" class="beher-claims__card" data-start="' +
              c.id +
              '"><span class="beher-claims__card-icon">' +
              ICONS[c.icon] +
              '</span><span class="beher-claims__card-body"><span class="beher-claims__card-title">' +
              escapeHtml(c.title) +
              '</span><span class="beher-claims__card-subtitle">' +
              escapeHtml(c.subtitle) +
              "</span></span></button>"
            );
          })
          .join("") +
        "</div>";
      var el = setStage(html);
      el.querySelectorAll("[data-start]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var type = btn.getAttribute("data-start");
          track("beher_claim_type_selected", { claim_type: type });
          startFlow(type);
        });
      });
      track("beher_claim_center_view", {});
    }

    function startFlow(type) {
      state.claimType = type;
      state.claimSubtype = null;
      state.orderNumber = "";
      state.email = "";
      state.description = "";
      state.files = [];
      state.fields = {};
      if (type === "tracking") {
        state.currentFlow = FLOWS.tracking;
      } else {
        state.currentFlow = FLOWS[type];
      }
      state.currentIndex = 0;
      renderCurrentStep();
    }

    // ---------------------------------------------------------
    // STEP: tracking info (self-service)
    // ---------------------------------------------------------
    function renderTrackingInfo() {
      var hasAccountLink = !!cfg.accountOrdersUrl;
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>Where is my order?</h2>' +
        '<p class="beher-claims__step-copy">Use your order tracking to see the latest shipping updates.</p>' +
        (hasAccountLink
          ? ""
          : '<div class="beher-claims__alert beher-claims__alert--info">Open the shipping confirmation email we sent you and select \u201cView your order\u201d to see the latest UPS tracking update.</div>') +
        '<div class="beher-claims__actions">' +
        (hasAccountLink
          ? '<a class="beher-claims__button beher-claims__button--primary" href="' +
            escapeHtml(cfg.accountOrdersUrl) +
            '">View my orders</a>'
          : "") +
        '<button type="button" class="beher-claims__button ' +
        (hasAccountLink ? "beher-claims__button--secondary" : "beher-claims__button--primary") +
        '" data-action="still-need-help">Still need help?</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", renderStart);
      el.querySelector('[data-action="still-need-help"]').addEventListener("click", function () {
        state.claimType = "delivery_issue";
        state.currentFlow = FLOWS.tracking_help;
        state.currentIndex = 0;
        renderCurrentStep();
      });
    }

    function renderTrackingIssueType() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>What happened?</h2>' +
        cardListHtml(TRACKING_ISSUE_CARDS, "trackingIssue");
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", renderStart);
      el.querySelectorAll("[data-card]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          pickSubtypeWithInfo(btn.getAttribute("data-card"));
        });
      });
    }

    function renderOrderFields(opts) {
      opts = opts || {};
      var emailRequired = opts.emailRequired !== false;
      var orderRequired = opts.orderRequired !== false;
      var descRequired = !!opts.descriptionRequired;
      var showDescription = opts.showDescription !== false;
      return (
        '<div class="beher-claims__field" data-field="orderNumber">' +
        '<label class="beher-claims__label" for="beher-order-number">Order number' +
        (orderRequired ? "" : " (optional)") +
        '</label>' +
        '<input class="beher-claims__input" id="beher-order-number" type="text" inputmode="text" placeholder="#12345" value="' +
        escapeHtml(state.orderNumber) +
        '">' +
        '<div class="beher-claims__field-error" data-error></div>' +
        "</div>" +
        '<div class="beher-claims__field" data-field="email">' +
        '<label class="beher-claims__label" for="beher-email">Email address</label>' +
        '<input class="beher-claims__input" id="beher-email" type="email" autocomplete="email" placeholder="name@example.com" value="' +
        escapeHtml(state.email) +
        '">' +
        '<div class="beher-claims__field-error" data-error></div>' +
        "</div>" +
        (showDescription
          ? '<div class="beher-claims__field" data-field="description">' +
            '<label class="beher-claims__label" for="beher-order-desc">Description' +
            (descRequired ? "" : " (optional)") +
            '</label>' +
            '<textarea class="beher-claims__textarea" id="beher-order-desc" placeholder="Add any details that may help us understand the issue.">' +
            escapeHtml(state.description) +
            "</textarea>" +
            '<div class="beher-claims__field-error" data-error></div>' +
            "</div>"
          : "")
      );
    }

    function bindOrderFields(el, opts) {
      opts = opts || {};
      el.querySelector("#beher-order-number") &&
        el.querySelector("#beher-order-number").addEventListener("input", function (e) {
          state.orderNumber = e.target.value;
        });
      el.querySelector("#beher-email") &&
        el.querySelector("#beher-email").addEventListener("input", function (e) {
          state.email = e.target.value;
        });
      el.querySelector("#beher-order-desc") &&
        el.querySelector("#beher-order-desc").addEventListener("input", function (e) {
          state.description = e.target.value;
        });
    }

    function validateOrderFields(el, opts) {
      opts = opts || {};
      var valid = true;
      clearFieldErrors(el);
      if (opts.orderRequired !== false && !normalizeOrder(state.orderNumber)) {
        setFieldError(el, "orderNumber", "Please enter your order number.");
        valid = false;
      }
      if (opts.emailRequired !== false) {
        if (!state.email.trim()) {
          setFieldError(el, "email", "Please enter your email address.");
          valid = false;
        } else if (!isValidEmail(state.email)) {
          setFieldError(el, "email", "Please enter a valid email address.");
          valid = false;
        }
      } else if (state.email.trim() && !isValidEmail(state.email)) {
        setFieldError(el, "email", "Please enter a valid email address.");
        valid = false;
      }
      if (opts.descriptionRequired && !state.description.trim()) {
        setFieldError(el, "description", "Please add a short description.");
        valid = false;
      }
      return valid;
    }

    function setFieldError(el, fieldName, msg) {
      var field = el.querySelector('[data-field="' + fieldName + '"]');
      if (!field) return;
      field.classList.add("has-error");
      var err = field.querySelector("[data-error]");
      if (err) err.textContent = msg;
    }
    function clearFieldErrors(el) {
      el.querySelectorAll(".beher-claims__field").forEach(function (f) {
        f.classList.remove("has-error");
      });
    }

    function renderTrackingOrder() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>A few details</h2>' +
        '<p class="beher-claims__step-copy">We\u2019ll use this to look into your order.</p>' +
        renderOrderFields({ orderRequired: true, emailRequired: true, showDescription: false }) +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      bindOrderFields(el);
      el.querySelector('[data-action="continue"]').addEventListener("click", function () {
        if (validateOrderFields(el, { orderRequired: true, emailRequired: true })) goNext();
      });
    }

    function renderTrackingDetails() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>Anything else we should know?</h2>' +
        '<div class="beher-claims__field" data-field="description">' +
        '<label class="beher-claims__label" for="beher-track-desc">Details (optional)</label>' +
        '<textarea class="beher-claims__textarea" id="beher-track-desc" placeholder="Add any details that may help us understand the issue.">' +
        escapeHtml(state.description) +
        "</textarea>" +
        "</div>" +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelector("#beher-track-desc").addEventListener("input", function (e) {
        state.description = e.target.value;
      });
      el.querySelector('[data-action="continue"]').addEventListener("click", goNext);
    }

    // ---------------------------------------------------------
    // STEP: orderInfo (shared by quality / shipping_damage / order_item_issue)
    // ---------------------------------------------------------
    function renderOrderInfo() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>Order information</h2>' +
        '<p class="beher-claims__step-copy">This helps our team locate your order.</p>' +
        renderOrderFields({ orderRequired: true, emailRequired: true, showDescription: false }) +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      bindOrderFields(el);
      el.querySelector('[data-action="continue"]').addEventListener("click", function () {
        if (validateOrderFields(el, { orderRequired: true, emailRequired: true })) goNext();
      });
    }

    function renderQualityType() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>What seems to be the problem?</h2>' +
        cardListHtml(QUALITY_CARDS, "quality");
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelectorAll("[data-card]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          pickSubtypeWithInfo(btn.getAttribute("data-card"));
        });
      });
    }

    function renderDamageType() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>What was damaged?</h2>' +
        cardListHtml(DAMAGE_CARDS, "damage");
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelectorAll("[data-card]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          pickSubtypeWithInfo(btn.getAttribute("data-card"));
        });
      });
    }

    // Guarda el subtipo, reconstruye el flujo (con o sin pantalla info)
    // y avanza. Si hay info para ese problema, el siguiente paso es "info".
    function pickSubtypeWithInfo(subtype) {
      state.claimSubtype = subtype;
      state.currentFlow = buildFlow(state.claimType, subtype);
      track("beher_claim_subtype_selected", { claim_type: state.claimType, subtype: subtype });
      goNext();
    }

    // ---------------------------------------------------------
    // STEP: info (pantalla informativa que puede resolver el caso)
    // ---------------------------------------------------------
    function renderInfo() {
      var info = getInfo(state.claimSubtype, state.claimType);
      if (!info) { goNext(); return; }
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>' + escapeHtml(info.title) + "</h2>" +
        (info.images.length
          ? '<div class="beher-claims__info-gallery beher-claims__info-gallery--' + info.images.length + '">' +
            info.images.map(function (img) {
              return '<figure class="beher-claims__info-figure"><img class="beher-claims__info-image" src="' +
                escapeHtml(img.src) + '" alt="' + escapeHtml(img.caption || info.title) + '" loading="lazy">' +
                (img.caption ? '<figcaption class="beher-claims__info-caption">' + escapeHtml(img.caption) + "</figcaption>" : "") +
                "</figure>";
            }).join("") +
            "</div>"
          : "") +
        info.paragraphs.map(function (p) {
          return '<p class="beher-claims__step-copy">' + escapeHtml(p) + "</p>";
        }).join("") +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="solved">' + escapeHtml(info.solvedLabel) + '</button>' +
        '<button type="button" class="beher-claims__button beher-claims__button--secondary" data-action="continue">' +
        escapeHtml(info.continueLabel) + "</button>" +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelector('[data-action="solved"]').addEventListener("click", function () {
        track("beher_claim_deflected", { claim_type: state.claimType, subtype: state.claimSubtype });
        renderResolved();
      });
      el.querySelector('[data-action="continue"]').addEventListener("click", function () {
        track("beher_claim_info_continue", { claim_type: state.claimType, subtype: state.claimSubtype });
        goNext();
      });
    }

    function renderResolved() {
      var progress = root.querySelector("[data-beher-progress]");
      var plabel = root.querySelector("[data-beher-progress-label]");
      if (progress) progress.hidden = true;
      if (plabel) plabel.hidden = true;
      var html =
        '<h2 class="beher-claims__step-heading" data-focus-heading>Glad we could help</h2>' +
        '<p class="beher-claims__step-copy">No claim has been sent. If anything changes, you can come back and file one at any time.</p>' +
        '<div class="beher-claims__actions">' +
        '<a class="beher-claims__button beher-claims__button--primary" href="/">Back to BEHER.US</a>' +
        '<button type="button" class="beher-claims__button beher-claims__button--secondary" data-action="restart">File a different claim</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="restart"]').addEventListener("click", renderStart);
    }

    function renderItemIssueType() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>What happened?</h2>' +
        cardListHtml(ITEM_ISSUE_CARDS, "itemIssue");
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelectorAll("[data-card]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state.claimSubtype = btn.getAttribute("data-card");
          goNext();
        });
      });
    }

    function renderItemIssueFields() {
      var f = state.fields;
      var heading = "A few more details";
      var fieldsHtml = "";
      if (state.claimSubtype === "missing_item") {
        fieldsHtml =
          '<div class="beher-claims__field" data-field="item_name">' +
          '<label class="beher-claims__label" for="beher-item-name">Which item is missing?</label>' +
          '<input class="beher-claims__input" id="beher-item-name" type="text" value="' +
          escapeHtml(f.item_name || "") +
          '">' +
          '<div class="beher-claims__field-error" data-error></div></div>';
      } else if (state.claimSubtype === "wrong_item") {
        fieldsHtml =
          '<div class="beher-claims__field" data-field="expected_item">' +
          '<label class="beher-claims__label" for="beher-expected-item">What did you expect to receive?</label>' +
          '<input class="beher-claims__input" id="beher-expected-item" type="text" value="' +
          escapeHtml(f.expected_item || "") +
          '"><div class="beher-claims__field-error" data-error></div></div>' +
          '<div class="beher-claims__field" data-field="received_item">' +
          '<label class="beher-claims__label" for="beher-received-item">What did you receive?</label>' +
          '<input class="beher-claims__input" id="beher-received-item" type="text" value="' +
          escapeHtml(f.received_item || "") +
          '"><div class="beher-claims__field-error" data-error></div></div>';
      } else if (state.claimSubtype === "wrong_quantity") {
        fieldsHtml =
          '<div class="beher-claims__field" data-field="product">' +
          '<label class="beher-claims__label" for="beher-product">Product</label>' +
          '<input class="beher-claims__input" id="beher-product" type="text" value="' +
          escapeHtml(f.product || "") +
          '"><div class="beher-claims__field-error" data-error></div></div>' +
          '<div class="beher-claims__field" data-field="expected_qty">' +
          '<label class="beher-claims__label" for="beher-expected-qty">Expected quantity</label>' +
          '<input class="beher-claims__input" id="beher-expected-qty" type="text" value="' +
          escapeHtml(f.expected_qty || "") +
          '"><div class="beher-claims__field-error" data-error></div></div>' +
          '<div class="beher-claims__field" data-field="received_qty">' +
          '<label class="beher-claims__label" for="beher-received-qty">Received quantity</label>' +
          '<input class="beher-claims__input" id="beher-received-qty" type="text" value="' +
          escapeHtml(f.received_qty || "") +
          '"><div class="beher-claims__field-error" data-error></div></div>';
      } else {
        // other_item_issue -> just move to details step, skip this screen
        goNext();
        return;
      }
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>' +
        heading +
        "</h2>" +
        fieldsHtml +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelectorAll("input").forEach(function (input) {
        input.addEventListener("input", function () {
          var field = input.closest("[data-field]").getAttribute("data-field");
          f[field] = input.value;
        });
      });
      el.querySelector('[data-action="continue"]').addEventListener("click", function () {
        var valid = true;
        clearFieldErrors(el);
        el.querySelectorAll("[data-field]").forEach(function (field) {
          var name = field.getAttribute("data-field");
          if (!String(f[name] || "").trim()) {
            setFieldError(el, name, "This field is required.");
            valid = false;
          }
        });
        if (valid) goNext();
      });
    }

    function renderOtherFields() {
      var html =
        '<h2 class="beher-claims__step-heading" data-focus-heading>Something else</h2>' +
        '<p class="beher-claims__step-copy">Tell us what\u2019s going on and we\u2019ll route it to the right team.</p>' +
        '<div class="beher-claims__field" data-field="email">' +
        '<label class="beher-claims__label" for="beher-other-email">Email address</label>' +
        '<input class="beher-claims__input" id="beher-other-email" type="email" autocomplete="email" value="' +
        escapeHtml(state.email) +
        '"><div class="beher-claims__field-error" data-error></div></div>' +
        '<div class="beher-claims__field" data-field="orderNumber">' +
        '<label class="beher-claims__label" for="beher-other-order">Order number (optional)</label>' +
        '<input class="beher-claims__input" id="beher-other-order" type="text" placeholder="#12345" value="' +
        escapeHtml(state.orderNumber) +
        '"></div>' +
        '<div class="beher-claims__field" data-field="topic">' +
        '<label class="beher-claims__label" for="beher-other-topic">Topic</label>' +
        '<input class="beher-claims__input" id="beher-other-topic" type="text" value="' +
        escapeHtml(state.fields.topic || "") +
        '"><div class="beher-claims__field-error" data-error></div></div>' +
        '<div class="beher-claims__field" data-field="description">' +
        '<label class="beher-claims__label" for="beher-other-desc">Description</label>' +
        '<textarea class="beher-claims__textarea" id="beher-other-desc" placeholder="Add any details that may help us understand the issue.">' +
        escapeHtml(state.description) +
        "</textarea><div class=\"beher-claims__field-error\" data-error></div></div>" +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      bindOrderFields(el);
      el.querySelector("#beher-other-topic").addEventListener("input", function (e) {
        state.fields.topic = e.target.value;
      });
      el.querySelector('[data-action="continue"]').addEventListener("click", function () {
        var valid = true;
        clearFieldErrors(el);
        if (!state.email.trim()) {
          setFieldError(el, "email", "Please enter your email address.");
          valid = false;
        } else if (!isValidEmail(state.email)) {
          setFieldError(el, "email", "Please enter a valid email address.");
          valid = false;
        }
        if (!String(state.fields.topic || "").trim()) {
          setFieldError(el, "topic", "Please add a short topic.");
          valid = false;
        }
        if (!state.description.trim()) {
          setFieldError(el, "description", "Please add a short description.");
          valid = false;
        }
        if (valid) goNext();
      });
    }

    // ---------------------------------------------------------
    // STEP: details
    // ---------------------------------------------------------
    function renderDetails() {
      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>Anything else we should know?</h2>' +
        (state.claimType === "quality"
          ? '<div class="beher-claims__field" data-field="lot">' +
            '<label class="beher-claims__label" for="beher-lot-number">Lot / label number (optional)</label>' +
            '<input class="beher-claims__input" type="text" id="beher-lot-number" autocomplete="off" maxlength="60" placeholder="e.g. L2406-118" value="' +
            escapeHtml(state.fields.lot_number || "") + '">' +
            '<p class="beher-claims__hint">You\u2019ll find it printed on the label of the pack, next to the best-before date. It helps us trace your product.</p>' +
            "</div>"
          : "") +
        '<div class="beher-claims__field" data-field="description">' +
        '<textarea class="beher-claims__textarea" id="beher-details-desc" placeholder="Add any details that may help us understand the issue.">' +
        escapeHtml(state.description) +
        "</textarea>" +
        "</div>" +
        '<p class="beher-claims__hint beher-claims__photo-note">' + escapeHtml(photoNotice()) + "</p>" +
        '<div class="beher-claims__actions">' +
        '<button type="button" class="beher-claims__button beher-claims__button--primary" data-action="continue">Continue</button>' +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      var lotEl = el.querySelector("#beher-lot-number");
      if (lotEl) {
        lotEl.addEventListener("input", function (e) {
          state.fields.lot_number = e.target.value;
        });
      }
      el.querySelector("#beher-details-desc").addEventListener("input", function (e) {
        state.description = e.target.value;
      });
      el.querySelector('[data-action="continue"]').addEventListener("click", goNext);
    }

    // ---------------------------------------------------------
    // STEP: review
    // ---------------------------------------------------------
    function photoNotice() {
      return (
        cfg.copy.photoNotice ||
        "Our support team may also ask you for photos or videos of the product. Please keep them ready so we can resolve your claim faster."
      );
    }

    function subtypeLabel() {
      var all = QUALITY_CARDS.concat(DAMAGE_CARDS, TRACKING_ISSUE_CARDS);
      for (var i = 0; i < all.length; i++) {
        if (all[i].id === state.claimSubtype) return all[i].title;
      }
      return state.claimSubtype
        ? state.claimSubtype
            .replace(/_/g, " ")
            .replace(/\b\w/g, function (c) {
              return c.toUpperCase();
            })
        : "";
    }

    function reviewRow(key, value, stepId) {
      if (!value) return "";
      return (
        '<div class="beher-claims__review-row"><span class="beher-claims__review-key">' +
        escapeHtml(key) +
        '</span><span class="beher-claims__review-value">' +
        escapeHtml(value) +
        (stepId
          ? '<button type="button" class="beher-claims__review-edit" data-edit="' + stepId + '">Edit</button>'
          : "") +
        "</span></div>"
      );
    }

    function renderReview() {
      var rows = "";
      rows += reviewRow("Issue", CLAIM_TYPE_LABELS[state.claimType] || state.claimType, findStepFor("type"));
      if (state.orderNumber) rows += reviewRow("Order", "#" + normalizeOrder(state.orderNumber), findStepFor("order"));
      if (state.email) rows += reviewRow("Email", state.email, findStepFor("order"));
      if (state.claimSubtype) rows += reviewRow("Problem", subtypeLabel(), findStepFor("type"));
      Object.keys(state.fields).forEach(function (k) {
        if (k === "topic") return;
        if (state.fields[k]) rows += reviewRow(k.replace(/_/g, " "), state.fields[k], findStepFor("fields"));
      });
      if (state.fields.topic) rows += reviewRow("Topic", state.fields.topic, findStepFor("fields"));
      if (state.description) rows += reviewRow("Details", state.description, findStepFor("details"));

      var html =
        backButtonHtml() +
        '<h2 class="beher-claims__step-heading" data-focus-heading>Review your claim</h2>' +
        '<div class="beher-claims__review-list">' +
        rows +
        "</div>" +
        '<div class="beher-claims__alert beher-claims__alert--info" role="note"><strong>Heads up:</strong> ' + escapeHtml(photoNotice()) + "</div>" +
        (cfg.copy.privacy ? '<p class="beher-claims__privacy">' + escapeHtml(cfg.copy.privacy) + "</p>" : "") +
        '<div class="beher-claims__actions">' +
        '<button type="submit" class="beher-claims__button beher-claims__button--primary" data-action="submit">' +
        '<span class="beher-claims__spinner"></span><span class="beher-claims__button-label">Submit claim</span>' +
        "</button>" +
        "</div>";
      var el = setStage(html);
      el.querySelector('[data-action="back"]').addEventListener("click", goBack);
      el.querySelectorAll("[data-edit]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var idx = state.currentFlow.indexOf(btn.getAttribute("data-edit"));
          if (idx > -1) {
            state.currentIndex = idx;
            renderCurrentStep();
          }
        });
      });
      // El botón es type="submit": un click real dispara el submit nativo
      // del formulario. El feedback visual (spinner/disabled) se aplica en
      // el listener 'submit' del formulario, NO aquí en 'click' — desactivar
      // el propio botón dentro de su handler de click puede cancelar el
      // envío nativo en varios navegadores.
      fillNativeFields();
      track("beher_claim_step_view", { claim_type: state.claimType, step: "review" });
    }

    function findStepFor(kind) {
      var map = {
        type: ["qualityType", "damageType", "itemIssueType", "trackingIssueType"],
        order: ["orderInfo", "trackingOrder"],
        fields: ["itemIssueFields", "otherFields"],
        details: ["details", "trackingDetails", "otherFields"]
      };
      var candidates = map[kind] || [];
      for (var i = 0; i < candidates.length; i++) {
        if (state.currentFlow.indexOf(candidates[i]) > -1) return candidates[i];
      }
      return null;
    }

    // ---------------------------------------------------------
    // Navigation
    // ---------------------------------------------------------
    var STEP_RENDERERS = {
      start: renderStart,
      trackingInfo: renderTrackingInfo,
      trackingIssueType: renderTrackingIssueType,
      trackingOrder: renderTrackingOrder,
      trackingDetails: renderTrackingDetails,
      orderInfo: renderOrderInfo,
      qualityType: renderQualityType,
      damageType: renderDamageType,
      itemIssueType: renderItemIssueType,
      itemIssueFields: renderItemIssueFields,
      otherFields: renderOtherFields,
      info: renderInfo,
      details: renderDetails,
      review: renderReview
    };

    function renderCurrentStep() {
      renderProgress();
      var stepId = state.currentFlow[state.currentIndex];
      track("beher_claim_step_view", { claim_type: state.claimType, step: stepId });
      (STEP_RENDERERS[stepId] || renderStart)();
    }

    function goNext() {
      if (state.currentIndex < state.currentFlow.length - 1) {
        state.currentIndex++;
        renderCurrentStep();
      }
    }
    function goBack() {
      if (state.currentIndex > 0) {
        state.currentIndex--;
        renderCurrentStep();
      } else {
        renderStart();
      }
    }

    // ---------------------------------------------------------
    // Submit — el formulario ES el Contact Form nativo de Shopify.
    // El botón "Submit claim" de renderReview() es type="submit": un click
    // dispara un submit real del navegador (necesario para que el script
    // de reCAPTCHA que Shopify inyecta pueda generar su token antes de
    // enviar — un fetch()/AJAX se lo salta y Shopify responde 400).
    // Aquí solo rellenamos los campos ocultos justo antes de que el
    // navegador procese ese submit real; no hacemos preventDefault.
    // El email llega a Settings > Notifications > Customer contact form.
    // ---------------------------------------------------------
    function buildContactBody() {
      var lines = ["BEHER.US CUSTOMER CLAIM", ""];
      lines.push("Claim type: " + (CLAIM_TYPE_LABELS[state.claimType] || state.claimType));
      if (state.claimSubtype) lines.push("Issue: " + subtypeLabel());
      if (state.orderNumber) lines.push("Order: #" + normalizeOrder(state.orderNumber));
      lines.push("Customer email: " + state.email.trim());
      Object.keys(state.fields).forEach(function (k) {
        if (state.fields[k]) lines.push(k.replace(/_/g, " ") + ": " + state.fields[k]);
      });
      if (state.description.trim()) {
        lines.push("");
        lines.push("Description:");
        lines.push(state.description.trim());
      }
      lines.push("");
      lines.push("Photos/videos: not attached (support may request them by email if needed)");
      lines.push("Submitted: " + new Date().toISOString());
      lines.push("Source: BEHER.US Claims Center");
      return lines.join("\n");
    }

    // Rellena los campos reales del Contact Form. Se llama al abrir la
    // pantalla de review Y justo antes del submit, así el contenido ya
    // está en el formulario antes de que cualquier script de Shopify
    // (reCAPTCHA) lo lea.
    function fillNativeFields() {
      if (!nativeForm) return;
      var e = nativeForm.querySelector("[data-native-contact-email]");
      var b = nativeForm.querySelector("[data-native-contact-body]");
      if (e) e.value = state.email.trim();
      if (b) b.value = buildContactBody();
    }

    // Evita que Enter dentro de un campo envíe el formulario antes de
    // tiempo (submit con email/cuerpo vacíos). Enter = pulsar "Continue".
    stage.addEventListener("keydown", function (ev) {
      if (ev.key !== "Enter" || ev.target.tagName !== "INPUT") return;
      ev.preventDefault();
      var next = stage.querySelector('[data-action="continue"]');
      if (next) next.click();
    });

    if (nativeForm) {
      nativeForm.addEventListener("submit", function (ev) {
        // Seguridad: si por lo que sea no hay email o cuerpo, no enviamos
        // un contacto vacío.
        if (!state.email.trim() || !state.claimType) {
          ev.preventDefault();
          return;
        }
        track("beher_claim_submit", { claim_type: state.claimType });
        fillNativeFields();

        var btn = nativeForm.querySelector('[data-action="submit"]');
        if (btn) {
          btn.classList.add("is-loading");
          var label = btn.querySelector(".beher-claims__button-label");
          if (label) label.textContent = "Submitting your claim\u2026";
          // El disabled se aplica con un pequeño retraso: hacerlo en el
          // mismo tick del 'submit' puede cancelar el envío nativo en
          // algunos navegadores. Esto solo evita un doble click mientras
          // la página ya está navegando hacia /contact.
          setTimeout(function () {
            btn.disabled = true;
          }, 0);
          // Si en 20 s la página no ha navegado (bloqueador, red caída,
          // reCAPTCHA que no responde), devolvemos el botón para reintentar
          // en vez de dejar al cliente atascado en "Submitting...".
          setTimeout(function () {
            if (!document.body.contains(btn)) return;
            btn.disabled = false;
            btn.classList.remove("is-loading");
            if (label) label.textContent = "Submit claim";
            if (!stage.querySelector("[data-submit-timeout]")) {
              var warn = document.createElement("div");
              warn.className = "beher-claims__alert beher-claims__alert--error";
              warn.setAttribute("data-submit-timeout", "");
              warn.textContent = "This is taking longer than expected. Please check your connection, disable any ad blocker for this page and try again.";
              btn.parentNode.parentNode.insertBefore(warn, btn.parentNode);
            }
            track("beher_claim_submit_timeout", { claim_type: state.claimType });
          }, 20000);
        }
        // Sin preventDefault: dejamos que el navegador envíe de verdad.
      });
    }

    // ---------------------------------------------------------
    renderStart();
  }

  function boot() {
    document.querySelectorAll("[data-beher-claims]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();